import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
    selector: '[appSwiper]',
    standalone: false
})
export class SwiperDirective implements AfterViewInit {
  @Input() config?: SwiperOptions;
  @Output() swiperInit = new EventEmitter<boolean>();

  constructor(private el: ElementRef<SwiperContainer>) { }

  ngAfterViewInit(): void {
    Object.assign(this.el.nativeElement, this.config);
    this.el.nativeElement.initialize();
    this.swiperInit.emit(true);
  }
}
